import React, { useState, useEffect } from "react";
import "./Home.css";
import { Grid, Paper } from "@mui/material";
import { TextField } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import monitoring from "src/img/monitoring.png";
import ticketing from "src/img/ticketing.png";
import alarms from "src/img/alarms.png";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Form, useNavigate } from "react-router-dom";
import { useRoleContext } from "src/hooks/use-alert";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

export default function FullWidthGrid(props) {
  const loggedRoles = localStorage.getItem("roles");
  const { roles, setRoles } = useRoleContext();

  useEffect(() => {
    // Update the roles state when resData changes
    if (loggedRoles !== roles) {
      let rolesString = localStorage.getItem("roles");
      var rolesArray = rolesString === null ? [] : JSON.parse(rolesString);
      setRoles(rolesArray);
    }
  }, [loggedRoles, roles, setRoles]);

  const navigate = useNavigate();

  const handleNavigation = (path) => {
    if (path === "alerts-and-notifications" && roles.includes("mo")) {
      console.log(roles);
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else if (path === "monitoring" && roles.includes("mo")) {
      navigate("/dashboard/unauthorized"); // Redirect to unauthorized route
    } else {
      navigate(path);
    }
  };
  const [searchText, setSearchText] = useState("");
  const [isSidePanelVisible, setIsSidePanelVisible] = useState(false);
  const [filteredShortcuts, setFilteredShortcuts] = useState([]);

  const shortcuts = [
    { label: "Windowing", onClick: () => navigate("window"), policy: "window.view" },
    { label: "Manage Deals", onClick: () => navigate("deals"), policy: null },
    { label: "Report a Bug", onClick: () => navigate("ticketing/board"), policy: null },
    { label: "AI Chat Bot", onClick: null, policy: null },
  ];

  useEffect(() => {
    const filtered = shortcuts.filter((shortcut) =>
      shortcut.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredShortcuts(filtered);
  }, [searchText]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleToggleSidePanel = () => {
    setIsSidePanelVisible((prevState) => !prevState);
  };
  return (
    <div className="home">
      <div className="started">
        {props.children}
        <h1 className="titleContainerHome">
          <div className="getStarted">Getting Started</div>
          <div className="logoutButton">
            <Form action="/logout" method="post">
              <button>
                <PowerSettingsNewIcon
                  fontSize="small"
                  style={{
                    color: "#07070e",
                    backgroundColor: "#bbbcbd",
                    borderRadius: "50%",
                    padding: "3px",
                  }}
                />
                Logout
              </button>
            </Form>
          </div>
        </h1>
      </div>
      <div style={{ display: "flex", position: "relative", flexGrow: 1 }}>
        <div className="homeContainer">
          <Grid
            container
            paddingTop={"2%"}
            spacing={{ xs: 12, sm: 4, md: 4 }}
            /* gap={"60px 0px"} */
            className="homeContainerGrid"
          >
            <Grid
              item
              xs={12}
              sm={isSidePanelVisible ? 12 : 6}
              md={isSidePanelVisible ? 6 : 4}
              lg={isSidePanelVisible ? 4 : 4}
            >
              <div className="paperContainer">
                <Paper>
                  <div className="imageHolder">
                    <img src={monitoring} alt="monitoring" width={"100%"} />
                  </div>
                  <div className="mainButton">
                    <ButtonPolicy
                      policy="dashboard"
                      onClick={() => handleNavigation("monitoring")}
                      variant="contained"
                    >
                      Monitoring and Control
                    </ButtonPolicy>
                  </div>
                </Paper>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={isSidePanelVisible ? 6 : 4}
              sm={isSidePanelVisible ? 12 : 6}
              lg={isSidePanelVisible ? 4 : 4}
            >
              <div className="paperContainer">
                <Paper>
                  <div className="imageHolder">
                    <img src={ticketing} alt="ticketing" width={"100%"} />
                  </div>
                  <div className="mainButton">
                    <ButtonPolicy
                      policy="dashboard.ticketing"
                      onClick={() => handleNavigation("ticketing/board")}
                      variant="contained"
                    >
                      Ticketing
                    </ButtonPolicy>
                  </div>
                </Paper>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={isSidePanelVisible ? 12 : 4}
              sm={12}
              lg={isSidePanelVisible ? 4 : 4}
            >
              <div className="paperContainer">
                <Paper>
                  <div className="imageHolder">
                    <img src={alarms} alt="alarms" width={"100%"} />
                  </div>
                  <div className="mainButton">
                    <ButtonPolicy
                      policy="dashboard"
                      onClick={() =>
                        handleNavigation("alerts-and-notifications")
                      }
                      variant="contained"
                    >
                      Alarms and Notifications
                    </ButtonPolicy>
                  </div>
                </Paper>
              </div>
            </Grid>
          </Grid>
          {isSidePanelVisible && <Grid item width={320}></Grid>}
        </div>
        <div
          className="shortcutsContainer"
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            marginTop: "30px",
          }}
        >
          <div
            className={`sideShortcuts ${isSidePanelVisible ? "visible" : ""}`}
          >
            <Paper
              sx={{
                marginLeft: "30px",
                bgcolor: "#282B30",
                minHeight: "100%",
                width: 150,
                border: "2px solid #282B30",
                borderRadius: "0",
              }}
            >
              <div className="searchInput">
                <TextField
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search"
                  style={{ border: "1px solid #777a84" }}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: "#fbfcfd" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="shortcuts">
                <ul>
                  <li>
                    <h2>Shortcuts</h2>
                  </li>
                  {filteredShortcuts.map((shortcut, index) => (
                    <li key={index}>
                      <ButtonPolicy
                        className="windowingButtonPloicy"
                        onClick={shortcut.onClick}
                        policy={shortcut.policy}
                      >
                        {shortcut.label}
                      </ButtonPolicy>
                    </li>
                  ))}
                </ul>
              </div>
            </Paper>
          </div>
          <div className="toggleButtonContainer">
            <ButtonPolicy
              className={`toggleButton ${isSidePanelVisible ? "flipped" : ""}`}
              onClick={handleToggleSidePanel}
              variant="contained"
            >
              <span>Shortcuts</span>
            </ButtonPolicy>
          </div>
        </div>
      </div>
    </div>
  );
                  }